import React from 'react';
import {inject, observer} from 'mobx-react';
import TaskItem from './TaskItem';
import styles from './style.css';


const TasksList = inject('store', 'localizationStore')(observer(
    ({agentId, store, localizationStore, onEditTask, editable}) => {
        const agent = store.getAgentWithTasks(agentId)
        if (!agent) {
            return null
        }
        const locale = localizationStore.locale
        const tasks = agent.tasks.map(t => <TaskItem editable={editable} className={styles.task} task={t} onEditTask={onEditTask} agentId={agentId} key={t.id}/>)
        return (
            <div className={styles.container}>
                {tasks.length !== 0 ?
                    <div className={styles.list}>
                        {tasks}
                    </div>
                    :
                    <div className={styles.emptyList}>
                        <span>{locale.empty_tasks_list}</span>
                    </div>
                }
            </div>
        );
}))

export default TasksList;


// WEBPACK FOOTER //
// ./src/components/AgentInfo/components/TasksList/index.js